import { useState, useEffect } from "react"
import Hero from "./About/Hero"
import MissionSection from "./About/MissionSection"
import FounderStory from "./About/FounderStory"
import GamesOffered from "./About/GamesOffered"
import RoadmapSection from "./About/RoadmapSection"
import CTASection from "./About/CTASection"
import styles from "./about.module.css"
import { useTheme } from "@/components/context/ThemeContext"

export default function AboutPage() {
  const {theme} = useTheme();
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrolled = window.scrollY
      setScrollProgress((scrolled / windowHeight) * 100)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <main className={`${styles.aboutContainer} ${theme}`}>
      {/* Progress Bar */}
      <div className={styles.progressBar} style={{ width: `${scrollProgress}%` }} />

      <Hero />
      <MissionSection />
      <FounderStory />
      <GamesOffered />
      <RoadmapSection />
      <CTASection />
    </main>
  )
}
